import React, { Component } from 'react';
import { connect } from 'react-redux';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import MenuIcon from '@material-ui/icons/Menu';
import IconButton from '@material-ui/core/IconButton';
import NewWindow from 'react-new-window'

import Profile from './Profile';
//import Bulletin from './Bulletin';
//import BulletinNew from './BulletinNew';
//import ManageUser from './ManageUser';
//import ManageGroup from './ManageGroup';
import OnCallScheduleList from './OnCallScheduleList';
import { logoutUser } from '../actions/logout_actions';
import windowActions from '../actions/window_actions';

class MainMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      profile: this.props.profile,
      showBulletin: false,
      showUserManager: false,
      showGroupManager: false
    };
  }

  handleClickMainMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleCloseMainMenu = () => {
    this.setState({ anchorEl: null });
  };

  handleClickLogout = (event) => {
    event.preventDefault();
    localStorage.removeItem("token"); // Remove the token from localStorage
    this.props.logoutUser(); // Remove the user object from the Redux store
    this.setState({ anchorEl: null });
  };

  handleCloseMainMenuCallback = () => {
    this.setState({ anchorEl: null });
  };

  handleShowBulletin = () => {
    this.props.setBulletinDisplay(true);
    this.setState({ anchorEl: null });
  };

  handleShowUserManager = () => {
    this.props.setUserDisplay(true);
    this.setState({ anchorEl: null });
  };

  handleShowGroupManager = () => {
    this.props.setGroupDisplay(true);
    this.setState({ anchorEl: null });
  };

  handleMakeAnnouncement = () => {
    console.log("make announcement clicked");
    };

    handleSharepoint = () => {
        alert("testing");

        window.open("https://intelligentdirect.sharepoint.com/sites/Salesteam");
    };

  render() {
    const { anchorEl } = this.state;
    let onCallSchedule;
    let bulletin;
    let userManager;
    let groupManager;
    let userManagerMenuItem;
    let groupManagerMenuItem;

    // prevents undefined error
    let userRoles = this.props.profile.roles || "";

    if (userRoles.includes("A")) {
      userManagerMenuItem =
        <MenuItem onClick={this.handleShowUserManager}>User Manager</MenuItem>;
    }

    if (userRoles.includes("A")) {
      groupManagerMenuItem =
        <MenuItem onClick={this.handleShowGroupManager}>Group Manager</MenuItem>;
    }

    // OnCallSchedule on hold
    if (false) {
      onCallSchedule = <OnCallScheduleList callbackFromParent={this.handleCloseMainMenuCallback} />;
    }

    return (
      <div>
        <IconButton
          color="inherit"
          aria-label="Menu"
          aria-owns={anchorEl ? 'simple-menu' : undefined}
          aria-haspopup="true"
          onClick={this.handleClickMainMenu}
        >
          <Tooltip
            placement="bottom"
            enterDelay={500}
            title={
              <React.Fragment>
                <h6>
                  Main Menu
                </h6>
              </React.Fragment>
            }
          >
            <MenuIcon />
          </Tooltip>
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleCloseMainMenu}
        >
          <Profile onClick={this.handleCloseMainMenuCallback} callbackFromParent={this.handleCloseMainMenuCallback} />
          {onCallSchedule}
                <MenuItem onClick={this.handleShowBulletin}>View Bulletin</MenuItem>
                <MenuItem onClick={this.handleSharepoint}>MM Hub</MenuItem>
          {bulletin}
          {userManagerMenuItem}
          {userManager}
          {groupManagerMenuItem}
          {groupManager}
          {/*<MenuItem onClick={this.handleMakeAnnouncement}>Announcement</MenuItem>*/}
          <MenuItem onClick={this.handleClickLogout}>Logout</MenuItem>
        </Menu>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  //currentUser: state.reducer.currentUser
  profile: state.profile
})

const mapDispatchToProps = dispatch => ({
  //getProfileFetch: () => dispatch(getProfileFetch()),
  logoutUser: () => dispatch(logoutUser()),
  setBulletinDisplay: shouldDisplay => dispatch(windowActions['SET_BULLETIN'](shouldDisplay)),
  setUserDisplay: shouldDisplay => dispatch(windowActions['SET_USER_MANAGER'](shouldDisplay)),
  setGroupDisplay: shouldDisplay => dispatch(windowActions['SET_GROUP_MANAGER'](shouldDisplay)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MainMenu);


// WEBPACK FOOTER //
// ./src/components/MainMenu.js